import { useEffect } from 'react'

import Image from 'next/image'

import Box from '@ilg-totallymoney/ui/components/Box'
import Button from '@ilg-totallymoney/ui/components/Button'
import Card from '@ilg-totallymoney/ui/components/Card'
import Heading from '@ilg-totallymoney/ui/components/Heading'
import Text from '@ilg-totallymoney/ui/components/Text'

import useLogEvents from '@hooks/useLogEvents'

import womanHoldingPhoneImage from '../../public/images/woman-holding-phone.png'

interface EligibilityFactorsCardProps {
    numberOfRedEligibilityFactors: number
    route: 'alternativeProducts'
}

const EligibilityFactorsCard = ({
    numberOfRedEligibilityFactors,
    route,
}: EligibilityFactorsCardProps) => {
    const logEvents = useLogEvents()

    useEffect(() => {
        if (numberOfRedEligibilityFactors > 0) {
            logEvents.logEligibilityFactorsCardShownEvent({
                numberOfRedEligibilityFactors,
            })
        }
    }, [logEvents, numberOfRedEligibilityFactors])

    const onDeepLinkClick = (event: React.MouseEvent<HTMLElement>) => {
        event.preventDefault()
        logEvents.logEligibilityFactorsCardDeepLinkClickEvent({
            numberOfRedEligibilityFactors,
            route,
        })
        window.location.href = 'https://totallymoney.app.link/yM6QKnHBN1b'
    }

    if (numberOfRedEligibilityFactors === 0) {
        return null
    }

    return (
        <Card display="flex" p="space30" flexDirection="row">
            <Box mr="space20">
                <Image
                    src={womanHoldingPhoneImage}
                    width={64}
                    height={64}
                    alt="Woman holding a phone with an alert appearing"
                />
            </Box>
            <Box flex={1}>
                <Box mb="space10">
                    <Heading variant="40">Improve eligibility</Heading>
                </Box>
                <Box mb="space20">
                    <Text color="light" display="inline">
                        You have{' '}
                    </Text>
                    <Text weight="bold" display="inline">
                        {numberOfRedEligibilityFactors === 1
                            ? '1 thing'
                            : `${numberOfRedEligibilityFactors} things`}
                    </Text>
                    <Text color="light" display="inline">
                        {' '}
                        holding you back from getting better offers
                    </Text>
                </Box>
                <Button variant="primary" onClick={onDeepLinkClick}>
                    See in the app
                </Button>
            </Box>
        </Card>
    )
}

export default EligibilityFactorsCard
